import { defineComponent as _defineComponent } from 'vue'
import { inject, PropType, ref, nextTick, onMounted, watch } from "vue";
import LineInfoRow from "@/components/line/LineInfoRow.vue";
import { ILineInfoData, ILineInfoLite } from "@/domain/entities/lineInfo";
import { IBusStopData } from "@/domain/entities/busStop";
import InlineSvg from "vue-inline-svg";
import { useFavoriteBusStop } from "@/composables/busStop/useFavoriteBusStop";
import Modal from "../shared/modal/base/Modal.vue";
import { IFavoriteBusStop } from "@/domain/entities/favoriteBusStop";
import { useLineStore } from "@/stores/lineStore";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  RouterName,
  ShowErrorModal,
  ShowToastMessage,
} from "@/types";
import router from "@/router";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";


const __default__ = {
  name: "LineInfoList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  busStop: {
    type: Object as PropType<IBusStopData>,
    required: true,
  },
  lineInfos: {
    type: Array as PropType<Array<ILineInfoLite>>,
    required: true,
  },
},
  emits: ["onClickClose", "onClickLineInfo", "onContentHeightChange"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const lineStore = useLineStore();
const scrollContainer = ref<HTMLElement>();

const { isFavorite } = useFavoriteBusStop();

const handleError = (title: string, result: any) => {
  showErrorModal(
    title,
    result.errorMessage,
    result.resultCode,
    result.errorTime
  );
};

const convertToFavorietBusStop = (busStop: IBusStopData): IFavoriteBusStop => {
  const favoriteBusStop: IFavoriteBusStop = {
    uid: busStop.id,
    name: busStop.name,
    shorName: busStop.shortName ?? "",
    lat: busStop.latitude,
    lng: busStop.longitude,
    displayOrder: busStop.order ?? 0,
  };

  return favoriteBusStop;
};

const goToLineInfoDetail = (lineInfo: ILineInfoLite) => {
  router.push({
    name: RouterName.LineInfoDetail,
    params: {
      lineId: lineInfo.id,
    },
  });
};

/** 정류장 즐겨찾기 추가 */
const addFavoriteBusStop = async () => {
  const favoriteBusStop = convertToFavorietBusStop(props.busStop);
  const addResult = await lineStore.addFavoriteBusStop(favoriteBusStop);

  if (!addResult.isSuccess) {
    handleError("즐겨찾기 추가 오류", addResult);
    return;
  }

  showToastMessage("즐겨찾기가 추가되었습니다", 2500, 0);
};

/** 정류장 즐겨찾기 삭제 확인 모달 */
const shouldShowAlertToDeleteFavorite = ref(false);
const toggleShowAlertToDeleteFavorite = (show: boolean) => {
  shouldShowAlertToDeleteFavorite.value = show;
};

/** 정류장 즐겨찾기 삭제 */
const removeFavoriteBusStop = async () => {
  const removeResult = await lineStore.removeFavoriteBusStop(props.busStop.id);

  if (!removeResult.isSuccess) {
    handleError("즐겨찾기 삭제 오류", removeResult);
    return;
  }

  showToastMessage("즐겨찾기가 삭제되었습니다", 2500, 0);
};

const containerRef = ref<HTMLElement>();
const headerRef = ref<HTMLElement>();

// 컨텐츠 높이 계산 및 전달
const calculateAndEmitContentHeight = async () => {
  await nextTick();

  if (!containerRef.value || !headerRef.value) return;

  try {
    // 헤더 높이 계산
    const headerHeight = headerRef.value.offsetHeight;

    // 리스트 아이템들의 실제 높이 계산
    const listItems = containerRef.value.querySelectorAll(
      ".line-info-wrapper li"
    );
    let totalListHeight = 0;

    if (listItems.length > 0) {
      // 첫 번째 아이템의 높이를 기준으로 전체 높이 계산
      const firstItem = listItems[0] as HTMLElement;
      const firstItemHeight = firstItem.offsetHeight;
      totalListHeight = firstItemHeight * listItems.length;
    } else {
      // 아이템이 없을 경우 기본 높이 사용
      totalListHeight = 100;
    }

    // 여백 및 패딩 고려 (상단 8px margin + 하단 여백)
    const margins = 32;
    const totalContentHeight = headerHeight + totalListHeight + margins;

    emit("onContentHeightChange", totalContentHeight);
  } catch (error) {
    console.warn("높이 계산 중 오류 발생:", error);
    // 오류 시 기본 높이 사용
    emit("onContentHeightChange", 400);
  }
};

onMounted(() => {
  calculateAndEmitContentHeight();
});

watch(
  () => props.lineInfos,
  () => {
    calculateAndEmitContentHeight();
  },
  { deep: true }
);

const __returned__ = { props, emit, showErrorModal, showToastMessage, lineStore, scrollContainer, isFavorite, handleError, convertToFavorietBusStop, goToLineInfoDetail, addFavoriteBusStop, shouldShowAlertToDeleteFavorite, toggleShowAlertToDeleteFavorite, removeFavoriteBusStop, containerRef, headerRef, calculateAndEmitContentHeight, LineInfoRow, get InlineSvg() { return InlineSvg }, Modal, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})